import "core-js/modules/es.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var FocusAdvice = /*#__PURE__*/function (_lm$Composant) {
  function FocusAdvice() {
    _classCallCheck(this, FocusAdvice);
    return _callSuper(this, FocusAdvice, arguments);
  }
  _inherits(FocusAdvice, _lm$Composant);
  return _createClass(FocusAdvice, [{
    key: "initFocusAdvice",
    value: function initFocusAdvice(containerClass, elementName, message) {
      var containerElement = document.querySelector(containerClass);
      var input = document.getElementsByName(elementName)[0];
      if (input) {
        var newAdvice = document.createElement('span');
        newAdvice.textContent = message;
        newAdvice.classList.add('js-input-advice');
        newAdvice.classList.add('input-advice');
        newAdvice.setAttribute('id', "".concat(elementName, "--advice"));
        input.addEventListener('focus', function () {
          containerElement.appendChild(newAdvice);
          input.setAttribute('aria-describedby', "".concat(elementName, "--advice"));
        });
        input.addEventListener('focusout', function () {
          var advice = document.querySelector('.js-input-advice');
          advice.remove();
        });
      }
    }
  }, {
    key: "inputPhoneNumberAdvice",
    value: function inputPhoneNumberAdvice() {
      this.initFocusAdvice('.js-phone-number', 'telephone', 'Merci de privilégier un numéro de téléphone mobile.');
    }
  }]);
}(lm.Composant);